export default "__VITE_PUBLIC_ASSET__7deb98b5__"